import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import {
  Box,
  MenuItem,
  Select,
  SelectProps,
  styled,
  Typography
} from '@mui/material';
import React from 'react';
import { helperTextStyles, inputBaseStyles, requiredAsteriskStyles } from '../../styles/inputStyles';

export interface SelectOption {
  value: string | number;
  label: string;
}

interface SelectFieldProps extends Omit<SelectProps, 'variant'> {
  label?: string;
  helperText?: string;
  width?: string | number;
  optional?: boolean;
  options: SelectOption[];
  placeholder?: string;
}

const StyledSelect = styled(Select)(({ theme }) => ({
  ...inputBaseStyles,
  ...requiredAsteriskStyles,
}));

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  fontSize: '15px',
  color: '#000000',
  fontWeight: 400,
  fontFamily: 'Inter',
}));

const HelperText = styled(Typography)(() => ({
  ...helperTextStyles,
}));

const SelectField: React.FC<SelectFieldProps> = ({
  label,
  helperText,
  width,
  optional = false,
  required = false,
  options,
  placeholder = 'None',
  ...props
}) => {
  return (
    <Box>
      {label && (
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
          <Typography component="label" className="input-field-label">
            {label}
            {required && <span>*</span>}
          </Typography>
        </Box>
      )}
      <StyledSelect
        variant="outlined"
        required={required}
        displayEmpty={label ? false : true}
        IconComponent={KeyboardArrowDownIcon}
        {...props}
        {...{
          sx: {
            borderRadius: '8px !important',
            height: '31px !important',
            width: width || '100%',
            backgroundColor: '#fff',
            ...props.sx
          }
        }}
      >
        <StyledMenuItem value="">
          <div style={{ color: '#00000066', fontSize: '15px', fontWeight: 500 }}>{placeholder}</div>
        </StyledMenuItem>
        {options.map((option) => (
          <StyledMenuItem key={option.value} value={option.value}>
            {option.label}
          </StyledMenuItem>
        ))}
      </StyledSelect>
      {helperText && <HelperText>{helperText}</HelperText>}
    </Box>
  );
};

export default SelectField; 